let language = {
    "LBL_HOME":"Home",
    "LBL_ADD_SUBHEAD": "Create Sub Head",
    "LBL_VIEW_SUBHEAD": "View Sub Head",
    "LBL_SUBHEAD_NAME": "Name",
    "LBL_HEAD_NAME": "Group Head",
    "LBL_BRANCH": "Branch",
    "LBL_EMAIL": "Email",
    "LBL_PHONE":"Phone",
    "LBL_GENDER":"Gender",
    "LBL_IMAGE":"Image",
    "LBL_DOB":"DOB",
    "LBL_STATUS":"Status",
    "LBL_HOBBIES":"Hobbies",
    "LBL_SINGING":"Singing",
    "LBL_DANCE":"Dancing",
    "LBL_CREATE_DATE":"Date Created",
    "LBL_ENTERED":"Date Entered",
    "LBL_MODIFIED_DATE":"Date Modified",
    "LBL_DOWNLOAD_ONE":"Download 1",
    "LBL_DOWNLOAD_TWO":"Download 2",
    "LBL_EDIT":"Edit",
    "LBL_DELETE":"Delete",
    "LBL_SEQUENCE_NO":"Sequence No",
    "LBL_SUBHEAD_NARRATION":"Subhead Narration",
    "LBL_IS_CHANGEABLE":"Is Changeable",
}

export default language;